import { Select } from '@mantine/core';
import { useTranslation } from 'react-i18next';

interface CountrySelectorProps {
    value: string;
    onChange: (value: string | null) => void;
    disabled?: boolean;
    className?: string;
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl';
}

export default function CountrySelector({ value, onChange, disabled, className, size = 'sm' }: CountrySelectorProps): JSX.Element {
    const { t } = useTranslation();

    return (
        <Select
            className={className}
            size={size}
            label={t('country')}
            // placeholder={t('select_country')}
            value={value || ''}
            onChange={onChange}
            disabled={disabled}
            data={Object.entries(t('countries', { returnObjects: true }) as Record<string, string>).map(([code, name]) => ({
                value: code,
                label: name
            }))}
            searchable
        // clearable
        />
    );
}
